// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qq6Do","h1":"styles_h1__qkMuH","p":"styles_p__-95jq","button":"styles_button__-NXTm","spinner":"styles_spinner__9Odfa","spin":"styles_spin__qZNiA"};